module.exports = __webpack_public_path__ + "media/images/logo/Logo(V)_NavyOL-a61c7ea7c1146380adb49b454cc36f75.png";